declare interface IWebSettingsMenu {
  name: string;
  link: string;
  type: "custom" | "category";
  icon?: string;
  id: string;
}
export interface IWebSettingsMenus {
  menu: IWebSettingsMenu[];
}

export interface IWebSettings {
  header: IWebSettingsMenus;
  footer: IWebSettingsMenus;
}

export interface IWebSetting {
  _id: string;
  name: string;
  admin_title: string;
  web_title: string;
  description: string;
  logo: string;
  favicon: string;
  siteUrl: string;
  seo_title: string;
  meta_description: string;
  meta_keywords: string[];
  google_teg_manager: string;
  social_links: any[];
  copy_right_text: string;
  new_release_poster: string;
  webSettings: IWebSettings;
}

export interface IWebsiteSetting {
  message: string;
  data: IWebSetting;
}

export interface IGetManageSettingsQuery {
  select?: string;
}

export interface IUpdateSettings {
  id: string;
  name?: string;
  description?: string;
  siteUrl?: string;
  seo_title?: string;
  meta_description?: string;
  meta_keywords?: string[];
  google_teg_manager?: string;
  copy_right_text?: string;
  webSettings?: IWebSettings;

  logo?: File; // File
  favicon?: File; // File
  new_release_poster?: File; // File
}

export interface IUpdateSocialMedia {
  settings_id: string;
  action: "create" | "update" | "delete";
  id?: string;
  name?: string;
  link?: string;

  icon?: string; // File
}

export enum EStorageType {
  ASSETS_STORAGE = "assetsStorage",
  STORAGE = "storage",
}

/**
 * <p>Specifies a cross-origin access rule for an Amazon S3 bucket.</p>
 * @public
 */
export interface CORSRule {
  /**
   * <p>Unique identifier for the rule. The value cannot be longer than 255 characters.</p>
   * @public
   */
  ID?: string;
  /**
   * <p>Headers that are specified in the <code>Access-Control-Request-Headers</code> header.
   *          These headers are allowed in a preflight OPTIONS request. In response to any preflight
   *          OPTIONS request, Amazon S3 returns any requested headers that are allowed.</p>
   * @public
   */
  AllowedHeaders?: string[];
  /**
   * <p>An HTTP method that you allow the origin to execute. Valid values are <code>GET</code>,
   *             <code>PUT</code>, <code>HEAD</code>, <code>POST</code>, and <code>DELETE</code>.</p>
   * @public
   */
  AllowedMethods: string[] | undefined;
  /**
   * <p>One or more origins you want customers to be able to access the bucket from.</p>
   * @public
   */
  AllowedOrigins: string[] | undefined;
  /**
   * <p>One or more headers in the response that you want customers to be able to access from
   *          their applications (for example, from a JavaScript <code>XMLHttpRequest</code>
   *          object).</p>
   * @public
   */
  ExposeHeaders?: string[];
  /**
   * <p>The time in seconds that your browser is to cache the preflight response for the
   *          specified resource.</p>
   * @public
   */
  MaxAgeSeconds?: number;
}

export interface IUpdateCORSPayload {
  bucket: string;
  corsRules: CORSRule[];
  storageType: EStorageType;
}

export interface IUpdateCORSPayloadResponse {
  success: boolean;
  message: string;
}

export interface IGetCORSPayload {
  bucket: string;
  storageType: EStorageType;
}

export interface IGetCORSPayloadResponse {
  data: CORSRule[];
}
